<template>
  <footer class="app-footer online-footer">
    <div class="online-footer__label">
      <i class="fa fa-user"></i>
      <span>Staff online</span>
      <span class="online-footer__count" v-if="onlineCount">{{ onlineCount }}</span>
    </div>
    <div class="online-footer__list" v-if="sortedOnline.length">
      <router-link
        v-for="(staff, index) in sortedOnline"
        :key="staffKey(staff, index)"
        :id="'staff-online-' + staffKey(staff, index)"
        :to="'/user/' + staff.user + '/profile'"
        class="online-footer__item"
        :style="{color: role(staff.security)}"
      >
        <span class="online-footer__dot"></span>
        <span class="online-footer__name">{{ staff.user }}</span>
        <span class="online-footer__sep" v-if="index + 1 < sortedOnline.length">•</span>
      </router-link>
    </div>
    <div class="online-footer__empty" v-else>
      Nobody is online right now.
    </div>
  </footer>
</template>
<script>
    import {mapGetters} from 'vuex'
    import Roles from '../_roles'

    export default {
      name: 'c-footer',
      computed: {
        ...mapGetters(['currentOnline']),
        sortedOnline () {
          const online = Array.isArray(this.currentOnline) ? this.currentOnline.slice() : []
          online.sort((a, b) => {
            if (a.user < b.user) return -1
            if (a.user > b.user) return 1
            return 0
          })
          return online
        },
        onlineCount () {
          return Array.isArray(this.currentOnline) ? this.currentOnline.length : 0
        }
      },
      methods: {
        staffKey (staff, index) {
          return staff && staff.id ? staff.id : `${staff.user || 'staff'}-${index}`
        },
        role (r) {
          return Roles[r] ? Roles[r].colour : '#b8c2cc'
        }
      }
    }
</script>
